import { convertSimNaoEnumToBoolean } from '@mchat-rf/consulta-seguimento/converter-consultaSeguimento'
import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { ConsultaSeguimentoPergunta14Model } from './model-consultaSeguimentoPergunta14'

export const convertConsultaSeguimentoPergunta14ToInput = (
  value: ConsultaSeguimentoPergunta14Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_14_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_14_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_14_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_14_DEU_EXEMPLO_ABAIXO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_14_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_14_OLHA_SEUS_OLHOS?.PRECISA_DE_ALGUMA_COISA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_14_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_14_OLHA_SEUS_OLHOS?.BRINCANDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_14_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_14_OLHA_SEUS_OLHOS?.ALIMENTACAO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_14_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_14_OLHA_SEUS_OLHOS?.TROCA_FRALDAS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_14_07,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_14_OLHA_SEUS_OLHOS?.LENDO_HISTORIA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_14_08,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_14_OLHA_SEUS_OLHOS?.FALANDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_14_09,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_14_10,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_14_OLHA_SEUS_OLHOS_5_VEZES),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
